import { InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'

@InputType()
export class ResolveHaulerTemplateArgs extends ActionArgs {}
